import { BaseStore } from "@omni/types/enums/baseStore.enum";

export const getBaseStoreName = (baseStore: BaseStore) => {
    return baseStore.split("_")[0].toLowerCase();
};
